export default "<app-repository-policy-change-form></app-repository-policy-change-form>\n";